import React, { memo } from 'react'

import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

import Img from '../components/Img'
import Button from '../components/Button'

const ChartInfoSection = ({ slice }) => {
  const { primary, items } = slice

  return (
    <section className={`section chart-info-section ${primary?.page}`}>
      <div className="container">
        {items?.map((item) => (
          <div key={item} className={`chart-info-box ${item?.position}`}>
            <Img
              image={item?.image?.gatsbyImageData}
              alt={item?.image?.alt}
              className="chart-info-image"
            />
            <div className="chart-info-description">
              <PrismicRichText field={item?.title?.richText} />
              <p className="p-18">{item?.paragraph?.text}</p>
              <Button data={item} />
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default memo(ChartInfoSection)

export const query = graphql`
  fragment HomepageDataBodyCartInfo on PrismicHomepageDataBodyCartInfo {
    id
    items {
      title {
        richText
      }
      button_theme
      position
      paragraph {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      button_title {
        text
      }
      button_link {
        url
        target
      }
    }
  }
  fragment PageDataBodyCartInfo on PrismicPageDataBodyCartInfo {
    id
    primary {
      page
    }
    items {
      title {
        richText
      }
      button_theme
      position
      paragraph {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      button_title {
        text
      }
      button_link {
        url
        target
      }
    }
  }
  fragment SolutionsDataBodyCartInfo on PrismicSolutionsDataBodyCartInfo {
    id
    primary {
      page
    }
    items {
      title {
        richText
      }
      button_theme
      position
      paragraph {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      button_title {
        text
      }
      button_link {
        url
        target
      }
    }
  }
  fragment SolutionsDataBodyCartInfo on PrismicSolutionsDataBodyCartInfo {
    id
    primary {
      page
    }
    items {
      title {
        richText
      }
      button_theme
      position
      paragraph {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      button_title {
        text
      }
      button_link {
        url
        target
      }
    }
  }
  fragment TechnologyPageTemplateDataBodyCartInfo on PrismicTechnologyPageTemplateDataBodyCartInfo {
    id
    primary {
      page
    }
    items {
      title {
        richText
      }
      button_theme
      position
      paragraph {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      button_title {
        text
      }
      button_link {
        url
        target
      }
    }
  }
`
